import { SortDirection } from '../../../../shared/utils/constants';
import {
  VehicleGeofenceStatus,
  VehicleGeofenceReportSortParams,
} from '../types';

type SortFilterConfig = {
  defaultSortBy: VehicleGeofenceReportSortParams['sortBy'];
  defaultSortDirection: VehicleGeofenceReportSortParams['sortDirection'];
};

type EventTypeFilterConfig = {
  defaultStatus: VehicleGeofenceStatus;
};

export const SORT_FILTER: SortFilterConfig = {
  defaultSortBy: 'eventTime',
  defaultSortDirection: SortDirection.DESC,
};

export const GEOFENCE_STATUS_FILTER: EventTypeFilterConfig = {
  defaultStatus: VehicleGeofenceStatus.ALL,
};

export const FILTERS_CONTAINER_WIDTH = 600;

export const DURATION_FILTER = {
  min: 0,
  max: 130,
  default: 10,
  step: 10,
  marks: [
    {
      label: '0min',
      value: 0,
      valueInSeconds: 0,
    },
    {
      label: '5min',
      value: 10,
      valueInSeconds: 300,
    },
    {
      label: '10min',
      value: 20,
      valueInSeconds: 600,
    },
    {
      label: '15min',
      value: 30,
      valueInSeconds: 900,
    },
    {
      label: '20min',
      value: 40,
      valueInSeconds: 1200,
    },
    {
      label: '30min',
      value: 50,
      valueInSeconds: 1800,
    },
    {
      label: '45min',
      value: 60,
      valueInSeconds: 2700,
    },
    {
      label: '1h',
      value: 70,
      valueInSeconds: 3600,
    },
    {
      label: '1.5h',
      value: 80,
      valueInSeconds: 5400,
    },
    {
      label: '8h',
      value: 90,
      valueInSeconds: 28800,
    },
    {
      label: '12h',
      value: 100,
      valueInSeconds: 43200,
    },
    {
      label: '1d',
      value: 110,
      valueInSeconds: 86400,
    },
    {
      label: '1w',
      value: 120,
      valueInSeconds: 604800,
    },
    {
      label: '1 mo',
      value: 130,
      valueInSeconds: 2592000,
    },
  ],
};

// all values are in meters
export const PENETRATION_FILTER = {
  min: 0.5,
  max: 60,
  default: 5,
  step: 1,
};
